import { Layer, LayerType } from './layer';
import { BaseImageLayer, ImageSubstitutionType } from './imageLayer';

export class MapLayer extends BaseImageLayer {
    public displayPin = true;

    public pinFill = 'rgb(226, 32, 32)';

    public showPlaceholderOverlay = true;

    public substitutionType = ImageSubstitutionType.LocationMap;

    public lockAspectRatio = true;

    public constructor(id: number) {
        super(id, LayerType.map);
    }
}

export function isMapLayer(layer: Layer): layer is MapLayer {
    return layer.type === LayerType.map;
}
